export default "__VITE_ASSET__YLhxpHY5__"